// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"be88e01e","147":"be88e01e","408":"be88e01e"}[chunkId] + ".chunk.css";
};